(() => {
  if (window.rdCollectionCarousel) return;
  window.rdCollectionCarousel = true;
  let viewer, page, index, trigger, busy = false, navigating = false;
  const pages = new Map();
  const readPage = (grid) => ({
    items: Array.from(grid.querySelectorAll('[data-rd-photo]'), (item) => JSON.parse(item.dataset.rdPhoto)),
    next: grid.dataset.rdNext,
    previous: grid.dataset.rdPrevious,
    section: grid.dataset.id
  });
  const status = (message) => { viewer.querySelector('[role="status"]').textContent = message; };
  const buttons = () => {
    viewer.querySelector('[data-rd-add]').disabled = busy || navigating || !selected()?.available;
    viewer.querySelector('[data-direction="-1"]').disabled = busy || navigating || (index === 0 && !page.previous);
    viewer.querySelector('[data-direction="1"]').disabled = busy || navigating || (index === page.items.length - 1 && !page.next);
    viewer.querySelector('select').disabled = busy || navigating;
  };
  const selected = () => page.items[index].variants.find((variant) => String(variant.id) === viewer.querySelector('select').value);
  const price = () => {
    viewer.querySelector('.rd-carousel__price').textContent = selected()?.price || '';
    viewer.querySelector('[data-rd-add]').textContent = selected()?.available ? viewer.dataset.add : viewer.dataset.soldOut;
    buttons();
  };
  const render = () => {
    const photo = page.items[index];
    viewer.querySelector('h2').textContent = photo.title;
    const image = viewer.querySelector('img');
    image.hidden = !photo.image;
    if (photo.image) image.src = photo.image;
    else image.removeAttribute('src');
    image.alt = photo.alt;
    const select = viewer.querySelector('select');
    select.replaceChildren(...photo.variants.map((variant) => {
      const option = document.createElement('option');
      option.value = variant.id;
      option.textContent = `${variant.title} — ${variant.price}${variant.available ? '' : ` (${viewer.dataset.soldOut})`}`;
      option.disabled = !variant.available;
      return option;
    }));
    select.value = (photo.variants.find((variant) => variant.available) || photo.variants[0])?.id;
    select.hidden = photo.variants.length < 2;
    viewer.querySelector('label').hidden = select.hidden;
    status('');
    price();
  };
  const move = async (direction) => {
    if (busy || navigating) return;
    const nextIndex = index + direction;
    if (nextIndex >= 0 && nextIndex < page.items.length) {
      index = nextIndex;
      render();
      return;
    }
    const link = direction > 0 ? page.next : page.previous;
    if (!link) return;
    navigating = true;
    buttons();
    try {
      const url = new URL(link, location.origin);
      url.searchParams.set('section_id', page.section);
      const key = url.href;
      let nextPage = pages.get(key);
      if (!nextPage) {
        const response = await fetch(url);
        if (!response.ok) throw new Error();
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const grid = doc.querySelector('#product-grid');
        if (!grid) throw new Error();
        nextPage = readPage(grid);
        if (!nextPage.items.length) throw new Error();
        pages.set(key, nextPage);
      }
      if (!viewer.open) return;
      page = nextPage;
      index = direction > 0 ? 0 : page.items.length - 1;
      render();
    } catch {
      status(viewer.dataset.error);
    } finally {
      navigating = false;
      buttons();
    }
  };
  const add = async () => {
    const variant = selected();
    if (busy || navigating || !variant?.available) return;
    busy = true;
    buttons();
    status('');
    try {
      const cart = document.querySelector('cart-drawer');
      const sections = cart?.getSectionsToRender() || [{ id: 'cart-icon-bubble' }];
      const response = await fetch(window.routes.cart_add_url, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }], sections: sections.map((section) => section.id), sections_url: location.pathname })
      });
      const result = await response.json();
      if (!response.ok || result.status) {
        status(typeof result.description === 'string' ? result.description : viewer.dataset.error);
        return;
      }
      status(viewer.dataset.added);
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'rd-carousel', productVariantId: variant.id, cartData: result });
      }
      for (const section of sections) {
        const html = result.sections?.[section.id];
        if (!html) continue;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const selector = section.selector || '.shopify-section';
        const source = doc.querySelector(selector);
        const target = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
        if (target && source) target.innerHTML = source.innerHTML;
      }
      cart?.classList.remove('is-empty');
      cart?.querySelector('#CartDrawer-Overlay')?.addEventListener('click', () => cart.close());
    } catch {
      status(viewer.dataset.error);
    } finally {
      busy = false;
      buttons();
    }
  };
  const init = (dialog) => {
    if (dialog.dataset.ready) return;
    dialog.dataset.ready = 'true';
    dialog.querySelector('.rd-carousel__close').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('rd-carousel-open');
      trigger?.focus({ preventScroll: true });
    });
    dialog.addEventListener('keydown', (event) => {
      if (event.target.matches('select')) return;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        move(event.key === 'ArrowRight' ? 1 : -1);
      }
    });
    dialog.querySelectorAll('[data-direction]').forEach((button) => button.addEventListener('click', () => move(Number(button.dataset.direction))));
    dialog.querySelector('select').addEventListener('change', price);
    dialog.querySelector('[data-rd-add]').addEventListener('click', add);
  };
  document.addEventListener('click', (event) => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || busy || navigating) return;
    const link = event.target.closest('#product-grid [data-rd-photo] a[href]');
    if (!link) return;
    const item = link.closest('[data-rd-photo]');
    const photo = JSON.parse(item.dataset.rdPhoto);
    if (new URL(link.href).pathname !== new URL(photo.url, location.origin).pathname) return;
    viewer = document.querySelector('dialog.rd-carousel');
    if (!viewer?.showModal) return;
    event.preventDefault();
    init(viewer);
    trigger = link;
    const grid = item.closest('#product-grid');
    page = readPage(grid);
    index = Array.from(grid.querySelectorAll('[data-rd-photo]')).indexOf(item);
    render();
    viewer.showModal();
    document.documentElement.classList.add('rd-carousel-open');
  });
})();
